import { object, date, string, array } from 'yup';

export const updateValidationSchema = object().shape({
  expectedAt: date().nullable(),
  fromType: string().required(),
  fromLocation: object().when('fromType', {
    is: fromType => fromType === 'location',
    then: object().nullable().required(),
  }),
  fromAddress: object().when('fromType', {
    is: fromType => fromType === 'address',
    then: object().nullable().required(),
  }),
  toType: string().required(),
  toLocation: object().when('toType', {
    is: toType => toType === 'location',
    then: object().nullable().required(),
  }),
  toAddress: object().when('toType', {
    is: toType => toType === 'address',
    then: object().nullable().required(),
  }),
  method: object().nullable(),
});

export default object().shape({
  expectedAt: date().nullable(),
  contact: object().nullable(),
  fromType: string().required(),
  fromLocation: object().when('fromType', {
    is: fromType => fromType === 'location',
    then: object().nullable().required(),
  }),
  fromAddress: object().when('fromType', {
    is: fromType => fromType === 'address',
    then: object().nullable().required(),
  }),
  toType: string().required(),
  toLocation: object().when('toType', {
    is: toType => toType === 'location',
    then: object().nullable().required(),
  }),
  toAddress: object().when('toType', {
    is: toType => toType === 'address',
    then: object().nullable().required(),
  }),
  items: array().required().min(1),
  method: object().nullable(),
});
